import Vue from 'vue'
import VueRouter from 'vue-router'

//import Home from '../views/home.vue'
import Grid from '../views/grid.vue'

Vue.use(VueRouter)

const routes = [
  {
  path: '/',
  name: 'madsci',
  component: Grid,
  props: true
  }, {
  path: '/project/:projectName',
  name: 'madsci-project',
  component: Grid,
  props: true
  }/*, {
    path: '/private/6Qp6w=!W=H,jHqDv',
    name: 'madsci-private',
    component: Home,
    props: true
  }*/
]

const router = new VueRouter(
  {
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
  }
)

export default router